import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import { UserSiteAssignments } from '../../UserSiteAssignments';

interface UserSiteAccessCardProps {
  userId: string;
  userName: string;
}

export function UserSiteAccessCard({
  userId,
  userName,
}: UserSiteAccessCardProps) {
  return (
    <Card variant="outlined" data-testid="user-site-access-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Typography variant="h6" component="h3">
            Site Access
          </Typography>

          {/* Explanatory Text */}
          <Typography variant="body2" color="text.secondary">
            Controls which construction sites this user can access. Users can
            only view and manage data for sites they have been assigned to.
          </Typography>

          {/* Assignment Component */}
          <Box>
            <UserSiteAssignments userId={userId} userName={userName} />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
